import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, OnInit, Input, InjectionToken, PLATFORM_ID, OnDestroy, inject } from '@angular/core';
import { REQUEST, RESPONSE } from '../express.tokens';
import { NavigationCancel, NavigationEnd, Router, RouterLink } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { Response } from 'express';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';

@Component({
  selector: 'app-404',
  template: `
    <article class="error-404 section-outset-y topbar-padding-top">
      <div class="container text-center">
        <h1>{{ 'error-' + code + '-title' | fromDictionary }}</h1>
        <p class="text-max-width mx-auto">{{ 'error-' + code + '-text' | fromDictionary }}</p>
        <div class="error-404__content text-center mt-4">
          <a [routerLink]="'/'" class="button button--primary">
            {{ 'error-home-knop-tekst' | fromDictionary }}
          </a>
        </div>
      </div>
    </article>
  `,
  imports: [RouterLink, FromDictionaryPipe],
})
export class NotFoundComponent implements OnInit, OnDestroy {
  private platformId = inject<InjectionToken<Object>>(PLATFORM_ID);
  private response = inject<Response>(RESPONSE, { optional: true })!;
  private router = inject(Router);

  private _unsubscribe$ = new Subject<void>();
  code = 404;

  constructor() {
    const statusCodeFromUrl = parseInt(this.router.url.replace(/\//g, ''));
    this.code = statusCodeFromUrl ? statusCodeFromUrl : 404;
  }

  ngOnInit(): void {
    if (isPlatformServer(this.platformId)) {
      if (this.response) {
        this.response.status(this.code);
      }
    }

    // this.router.events.pipe(takeUntil(this._unsubscribe$)).subscribe(event => {
    //   if (isPlatformBrowser(this.platformId) && (event instanceof NavigationEnd || event instanceof NavigationCancel)) {
    //     window.scrollTo(0, 0);
    //   }
    // });
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
